import React from 'react';
import { useTranslation } from 'react-i18next';

import BaseIngredientCategory from 'classes/StandingData/BaseIngredientCategory/BaseIngredientCategory';

interface IProps {
	baseIngredientCategory: BaseIngredientCategory;
	selectedLanguage: string;
	handleValueChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const BaseIngredientCategoryLanguageInput = (props: IProps) => {
	const { t } = useTranslation();

	const renderContent = () => {
		return (
			<>
				<div className="row mt-12">
					<div className="col-12 mt-2">
						<div className="row mb-3">
							<label>{t('_general:DESCRIPTION')}</label>
							<div>
								<input
									value={
										props.baseIngredientCategory.nameTranslations[
											props.selectedLanguage
										] || ''
									}
									type="text"
									onChange={props.handleValueChange}
									className="form-control"
									name="nameTranslations"
									error-key={'NameTranslations'}
								/>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	};

	return <>{renderContent()}</>;
};

export default BaseIngredientCategoryLanguageInput;
